import { makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getProductName, updateHashAndJump } from "../../helpers/PosFunctions";
import { CaretDownIcon, CaretUpIcon, Pdf } from "../components/icons";
import { PageListContext } from "../context";

const useStyles = makeStyles((theme) => ({
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  root: {
    position: "fixed",
    top: 0,
    zIndex: 3,
    height: "100vh",
    width: "270px",
    backgroundColor: "#323534",
    "&.left": {
      left: 0
    },
    "&.right": {
      right: 0
    }
  },
  report: {
    position: "absolute",
    backgroundColor: "#323534",
    zIndex: 3001,
    left: 0,
    bottom: 0,
    width: "100%",
    "& .content": {
      marginLeft: "20px",
      marginBottom: "25px",
      fontSize: "12px",
      "& img": {
        height: "12px",
        width: "auto",
        // "#FF8D8D"
        filter:
          "invert(83%) sepia(57%) saturate(2887%) hue-rotate(303deg) brightness(102%) contrast(101%)"
      },
      "& a": {
        display: "flex",
        justifyContent: "row",
        alignItems: "center",
        gap: "5px",
        color: "#FF8D8D",
        textDecoration: "none",
        "&:hover": {
          cursor: "pointer"
        }
      }
    }
  },

  content: {
    fontFamily: "azo-sans-web !important",
    fontWeight: 400,
    color: "white",
    margin: "75px 15px 15px 15px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // "&.export": {
    //   "& > div:first-child": {
    //     display: "flex",
    //     flexDirection: "column",
    //     // gap: "15px"
    //   }
    // },
    "& .pagesContainer": {
      marginRight: "15px",
      "& p": {
        margin: 0
      },
      "& .comparisonPagesContainer": {
        marginRight: "-25px",
        paddingRight: "10px",
        height: "calc(100vh - 330px)",
        marginTop: "10px",
        overflowY: "auto",
        "& .comparisonPageLink": {
          marginLeft: "15px"
        }
      },

      "& .comparisonPageLinkContainer": {
        display: "flex",
        "&:not(:first-of-type)": {
          marginTop: "10px"
        },
        justifyContent: "space-between",
        "& .exportIcon": {
          // #E6E1E5
          filter:
            "invert(81%) sepia(1%) saturate(543%) hue-rotate(260deg) brightness(116%) contrast(87%)",
          "&:hover": {
            cursor: "pointer"
          },
          height: "14px",
          width: "auto",
          "& .pageLink": {
            marginTop: "0 !important"
          }
        }
      },
      "& .pageLink": {
        width: "fit-content",
        "&:not(.comparisonPageLink)": {
          marginTop: "15px"
        },
        "& span:not(.icon)": {
          marginRight: "5px"
        },
        "& .icon": {
          fontSize: "15px",
          position: "absolute",
          marginTop: "-1px",
          "&.down": {
            marginTop: "1px"
          }
        },
        display: "block",
        textDecoration: "none",
        marginLeft: "5px",
        color: "#E6E1E5",
        fontSize: "14px",
        "&:hover": {
          cursor: "pointer"
        }
      }
    },
    "& .top": {
      margin: 0,
      paddingTop: "10px",
      fontSize: "18px",
      fontWeight: 700,
      "&.disabled": {
        color: "#8C8B8C"
      },
      "&.sub": {
        color: "#E0E0E0",
        fontSize: "14px",
        marginTop: "20px"
      }
    },
    "& .buttonsContainer": {
      marginTop: "15px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      gap: "10px",
      alignItems: "center",
      flexWrap: "wrap",
      "& .cancel-btn": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        gap: "5px",
        alignItems: "center",
        "&:hover": {
          cursor: "pointer"
        },
        color: "#FF8D8D",
        fontSize: "12px",
        "& img": {
          height: "12px",
          width: "auto",
          // "#FF8D8D"
          filter:
            "invert(83%) sepia(57%) saturate(2887%) hue-rotate(303deg) brightness(102%) contrast(101%)"
        }
      },
      "& .export-sheet-btn": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: "0px",
        //SNACKBAR TESTING START
        // width: "210px", // original
        width: "100%",
        //SNACKBAR TESTING END
        alignItems: "center",
        gap: "8px",
        background: "#396A4D",
        borderRadius: "100px",
        color: "white",
        fontSize: "14px",
        height: "40px",
        "&.downloading": {
          background: "rgba(57, 106, 77, 0.5)",
          //SNACKBAR TESTING
          // width: "158px", //original
          //SNACKBAR TESTING END
          "&:hover": {
            cursor: "default"
          }
        },
        "& span.icon": {
          marginTop: "-3px",
          fontSize: "14px"
        },
        "& img.icon": {
          //SNACKBAR TESTING START
          position: "absolute",
          left: "30px",
          //SNACKBAR TESTING END
          height: "14px",
          width: "auto",
          // #ffffff
          filter:
            "invert(100%) sepia(0%) saturate(0%) hue-rotate(9deg) brightness(109%) contrast(104%)",
          animation: "$spin 2s linear infinite"
        },
        "&:hover": {
          cursor: "pointer"
        }
      }
    }
  },
  optionsContainer: {
    marginLeft: "15px",
    display: "flex",
    flexDirection: "column",
    fontSize: "14px",
    color: "#E0E0E0",
    "& .optionContainerLabel": {
      margin: 0,
      lineHeight: 1.25,
      fontWeight: 700
    },
    "& .optionLabel": {
      marginLeft: "5px"
    },
    "& .checkboxContainer": {
      lineHeight: 1.25,
      fontWeight: 400,
      marginTop: "15px",
      "& .disabled": {
        color: "#8C8B8C"
      },
      "& .sub": {
        marginLeft: "5px"
      },
      "& input:not(.disabled), & label:not(.disabled)": {
        "&:hover": {
          cursor: "pointer"
        }
      }
    },
    "& .optionContainerOptions": {
      marginLeft: "5px",
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      "& input:hover, & label:hover": {
        cursor: "pointer"
      }
    }
  },
  border: {
    paddingBottom: "20px",
    borderBottom: "1px solid #525654",
    marginLeft: "-15px",
    marginRight: "-30px"
  },
  disabled: {
    color: "#8C8B8C"
  }
}));

export function PosSidebar(props) {
  const {
    exportState,
    setExportState,
    readyToDownload,
    pageCount,
    cancelGenerate,
    snackbarText
  } = props;
  const downloading = !!exportState.generate && !readyToDownload;
  const urlParams = { history: useHistory(), location: useLocation() };
  const [showComparisonPages, setShowComparisonPages] = useState(false);
  const updateQueryString = () => {
    const { history, location } = urlParams;
    const params = new URLSearchParams(history.location.search);
    if (exportState.queryId === "product") {
      params.set("product", exportState.primaryProduct.id);
    } else params.set("deliverable", exportState.deliverableId);
    params.set(
      "pages",
      exportState.selectedPages === "all"
        ? "all"
        : [...exportState.selectedPages].join(",")
    );
    const {
      selectedBrandModels,
      selectedCompetitorModels,
      brandModels = [],
      competitorModels = []
    } = exportState;
    const comparedProducts = [];
    if (selectedBrandModels === "all")
      comparedProducts.push(...brandModels.map(({ id }) => id));
    if (selectedBrandModels !== "all")
      comparedProducts.push(...selectedBrandModels);
    if (selectedCompetitorModels === "all")
      comparedProducts.push(...competitorModels.map(({ id }) => id));
    if (selectedCompetitorModels !== "all")
      comparedProducts.push(...selectedCompetitorModels);
    params.set(
      "compared-products",
      comparedProducts.length === competitorModels.length + brandModels.length
        ? "all"
        : comparedProducts.join(",")
    );
    const search = params.toString();
    const { pathname, hash } = location;
    history.replace({ hash, pathname, search });
  };
  useEffect(() => {
    if (!!exportState.primaryProduct) {
      updateQueryString();
    }
    // eslint-disable-next-line
  }, [exportState]);

  const {
    brandModels = [],
    competitorModels = [],
    hash = "",
    tabLabels = []
  } = exportState || {};
  const classes = useStyles();
  const showBothComparisons =
    exportState.brandModels?.length > 0 &&
    exportState.competitorModels?.length > 0;
  const competitorOptions = competitorModels.map((p) => ({
    label: getProductName(p, ["brand", "model"]),
    value: p.id,
    key: "selectedCompetitorModels"
  }));
  const brandOptions = brandModels.map((p) => ({
    label: getProductName(p, ["brand", "model"]),
    value: p.id,
    key: "selectedBrandModels"
  }));
  //if only one comparison page is shown, make sure pages are properly numbered 1-4 vs 1-5
  const tabOptions = [
    ...tabLabels.slice(1).map((label, i) => ({
      label,
      value: !!showBothComparisons ? i + 3 : i + 2,
      key: "selectedPages"
    }))
  ];
  if (exportState.brandModels?.length > 0)
    tabOptions.unshift({
      label: "Epson vs. Epson",
      value: !!showBothComparisons ? 2 : 1,
      key: "selectedPages",
      subkey: "selectedBrandModels"
    });
  if (exportState.competitorModels?.length > 0)
    tabOptions.unshift({
      label: "Epson vs. Competitors",
      value: 1,
      key: "selectedPages",
      subkey: "selectedCompetitorModels"
    });
  const sourceOptionsMap = {
    selectedPages: tabOptions,
    selectedCompetitorModels: competitorOptions,
    selectedBrandModels: brandOptions
  };
  const report = () => (
    <div className={classes.report}>
      <div className="content">
        <a href="mailto:help&#064;&#112;&#114;&#111;&#100;&#117;&#099;&#116;&#098;&#111;&#120;&#046;&#099;&#111;&#109;?subject=Productbox%20Issue%20Report">
          <img
            src="/fontawesome/regular/triangle-exclamation.svg"
            alt="report"
          />
          Report an issue
        </a>
      </div>
    </div>
  );
  const optionsContainer = (options, sub = false, tabNum) => (
    <div className={classes.optionsContainer}>
      {options.map((o, i) => {
        const { label, value, key, subkey } = o;
        const optionChecked =
          exportState[key] === "all" || exportState[key]?.has(value);
        const optionId = `option-${key}-${i}`;
        const sourceOptions = sourceOptionsMap[key];
        const subOptions = sourceOptionsMap[subkey];
        let disabled = !!downloading || !!exportState.generate;
        if (exportState.selectedPages.size === 1) {
          //prevent last page item from being deselected
          if (!sub && optionChecked) disabled = true;
          //prevent last sub item from being deselected if that would deselect the last main item
          if (!!sub && exportState[key].size === 1 && optionChecked)
            disabled = true;
        }
        return (
          <div key={i} className={`checkboxContainer ${!!sub ? "sub" : ""}`}>
            <input
              disabled={disabled}
              className={`checkbox ${!!disabled ? "disabled" : ""}`}
              key={i}
              type="checkbox"
              value={value}
              checked={optionChecked}
              name={optionId}
              id={optionId}
              onChange={(e) => {
                const targetChecked = e.target.checked;
                const targetValue = Number.parseInt(e.target.value);
                const newState = {
                  ...exportState
                };
                //update the current value based on if it was checked or not
                let currentValue = newState[key];
                if (!!targetChecked) {
                  //if already "all" and something was added, keep as "all"
                  if (currentValue === "all") currentValue = "all";
                  //else just add checked value
                  else currentValue.add(targetValue);
                }
                if (!targetChecked) {
                  //if just "all", make a new set with unchecked item excluded
                  if (currentValue === "all") {
                    //exclude "all"
                    currentValue = sourceOptions.reduce((acc, o) => {
                      if (o.value !== targetValue) acc.add(o.value);
                      return acc;
                    }, new Set());
                    //if still a set, just delete that value
                  } else currentValue.delete(targetValue);
                }
                if (currentValue.size === sourceOptions.length)
                  currentValue = "all";
                //update new state
                newState[key] = currentValue;
                if (!!subkey) {
                  //if a comparison page is selected, check all its products
                  if (!!targetChecked) newState[subkey] = "all";
                  //if a comparison page is deselected, uncheck all its products
                  else newState[subkey] = new Set();
                }
                //if a product was checked/unchecked, adjust the pages selected accordingly
                if (!!sub) {
                  let curSelectedPages = newState.selectedPages;
                  //if a comparison was page was deselected but you select one of its products,
                  //add that page back and adjust selectedPages
                  if (!!targetChecked) {
                    if (curSelectedPages !== "all")
                      curSelectedPages.add(tabNum);
                    if (curSelectedPages.size === tabOptions.length)
                      curSelectedPages = "all";
                    //if a comparison was page was selected but you deselect one of its products,
                    //remove that page if no products are selected now
                  } else {
                    if (currentValue.size === 0) {
                      if (curSelectedPages === "all") {
                        curSelectedPages = new Set(
                          tabOptions.map(({ value }) => value)
                        );
                      }
                      curSelectedPages.delete(tabNum);
                    }
                  }
                  newState.selectedPages = curSelectedPages;
                }
                setExportState(newState);
              }}
            />
            <label
              className={`optionLabel ${
                !!downloading || !!exportState.generate ? "disabled" : ""
              }`}
              htmlFor={optionId}
              dangerouslySetInnerHTML={{ __html: label }}
            />
            {!!subOptions && optionsContainer(subOptions, true, value)}
          </div>
        );
      })}
    </div>
  );

  const { pageList = [] } = React.useContext(PageListContext);
  const border = <div className={classes.border} />;

  return (
    !!exportState.primaryProduct && (
      <div
        className={`${classes.root}  removeForExport ${
          !!exportState.primaryProduct ? "right" : "left"
        }`}
      >
        <div
          className={`${classes.content} ${
            !!exportState.primaryProduct ? "export" : ""
          }`}
        >
          <div>
            {!!exportState.primaryProduct && (
              <>
                <p className="top">Export Options</p>
                <p
                  className={`top sub ${
                    !!downloading || !!exportState.generate ? "disabled" : ""
                  }`}
                >
                  Pages
                </p>
                {optionsContainer(tabOptions)}
                {border}
                <div className="buttonsContainer">
                  <button
                    onClick={() =>
                      setExportState({ ...exportState, generate: true })
                    }
                    className={`export-sheet-btn ${
                      !!downloading ? "downloading" : ""
                    }`}
                    data-sheet-id={hash}
                    data-mapping-enabled="true"
                  >
                    {!downloading ? (
                      Pdf({ className: "icon" })
                    ) : (
                      <img
                        src="/fontawesome/solid/spinner.svg"
                        className="icon"
                        alt="generating"
                      />
                    )}
                    {!downloading
                      ? `Generate PDF (${pageCount} page${
                          pageCount > 1 ? "s" : ""
                        })`
                      : snackbarText || "Generating PDF"}
                  </button>
                  {!!downloading && (
                    <div className="cancel-btn" onClick={cancelGenerate}>
                      <img
                        src="/fontawesome/regular/circle-xmark.svg"
                        alt="cancel"
                      />{" "}
                      Cancel
                    </div>
                  )}
                </div>
              </>
            )}
            {!exportState.primaryProduct && (
              <>
                <p className="top">Contents</p>
                <div className="pagesContainer">
                  <p className="top sub">Pages</p>
                  {pageList.slice(0, 2).map(({ name, html_id }, i) => (
                    <a
                      className="pageLink"
                      key={i}
                      href={`#${html_id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        updateHashAndJump(`#${html_id}`, 60);
                      }}
                    >
                      {name}
                    </a>
                  ))}
                  <p
                    className="pageLink"
                    onClick={() => setShowComparisonPages(!showComparisonPages)}
                  >
                    <span>Comparison Pages</span>
                    {!showComparisonPages
                      ? CaretUpIcon({
                          className: "icon"
                        })
                      : CaretDownIcon({
                          className: "icon down"
                        })}
                  </p>
                  {showComparisonPages && (
                    <div className="comparisonPagesContainer">
                      {pageList.slice(2).map(({ name, html_id }, i) => (
                        <div key={i} className="comparisonPageLinkContainer">
                          <a
                            className="comparisonPageLink pageLink"
                            href={`#${html_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              updateHashAndJump(`#${html_id}`, 60);
                            }}
                          >
                            {name}
                          </a>
                          <img
                            src="/fontawesome/regular/file-export.svg"
                            alt="export"
                            className="exportIcon"
                            title="export"
                            onClick={() =>
                              setExportState({ ...exportState, navId: html_id })
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {border}
                </div>
              </>
            )}
          </div>
          {report()}
        </div>
      </div>
    )
  );
}
